'use client';

import Header from '../../components/Header';
import Footer from '../../components/Footer';
import AboutHero from './AboutHero';
import Mission from './Mission';
// import Team from './Team';
import Values from './Values';

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <AboutHero />
        <Mission />
        <Values />
        {/* <Team /> */}
      </main>
      <Footer />
    </div>
  );
}